<template>
  <div class="overflow-y-scroll">
    <div
      class="flex flex-col bg-white min-h-full transition-all duration-100 ease-in min-w-64 w-max-content w-max max-w-64 xxl:max-w-80 relative z-10"
    >
      <ul class="ml-5 mt-32">
        <!-- BEGIN List modules -->
        <!-- Filter depot documents modules when user is a beneficiary  -->
        <li
          v-for="mod in filteredModules"
          :key="mod.id"
          :id="mod.id"
          class="list-none"
        >
          <div
            :id="`form-menu-${mod.name}`"
            class="group leading-4 cursor-pointer table flex-wrap h-14 2xl:h-16 w-auto max-w-60 border border-transparent rounded-lg hover:bg-pink-600 hover:text-white focus:outline-none transition ease-in-out duration-150 text-gray-600"
            :class="{ 'bg-pink-300': infosPage.id_module === mod.id }"
            @click="infosPage.isFormChanged ? $emit('changePage') : null"
          >
            <div
              class="items-center p-4 2xl:p-5 rounded-lg text-indigo-600 group-hover:text-white group-hover:bg-pink-600 transition ease-in-out duration-150 m-1"
              :class="{ 'bg-pink-100': infosPage.id_module === mod.id }"
            >
              <icon :name="mod.icon" />
            </div>
            <router-link
              v-if="mod.pages.length > 0"
              :to="{
                name: mod.name + mod.pages[0].name,
                params: { id: infosPass.id_pass },
              }"
              class="table-cell text-base align-middle pl-1 pr-3 group-hover:text-white"
              :class="{
                'text-gray-900': infosPage.id_module === mod.id,
              }"
            >
              {{ mod.display_name }}
            </router-link>
            <p
              v-else
              class="text-base table-cell align-middle pl-1 pr-3 group-hover:text-white"
              :class="{ 'text-gray-900': infosPage.id_module === mod.id }"
            >
              {{ mod.display_name }}
            </p>
          </div>
          <ul
            class="pl-3"
            :class="{
              hidden: infosPage.id_module !== mod.id,
              'xl:table-row': infosPage.id_module === mod.id,
            }"
          >
            <!-- BEGIN List pages -->
            <li
              v-for="page in mod.pages.filter(
                (p) => getLibelle({ module: mod, page: p }) !== false
              )"
              :key="page.id"
              class="first:mt-5 pb-6 pl-5.5 ml-5 last:pl-6 break-words max-w-56 border-l border-gray-600 border-opacity-25 last:border-0 group list-none relative text-gray-600 text-sm font-light"
              :class="{
                'text-gray-900 font-normal': infosPage.id_page === page.id,
              }"
              @click="$emit('changePage')"
            >
              <div
                class="absolute inline-block text-center -ml-7.5 py-1 px-1 border rounded-full border-opacity-25"
                :class="{
                  'border-teal-600 bg-teal-300 group-hover:border-teal-600':
                    page.progress_goal <= page.progress,
                  'border-pink-600 bg-pink-300 group-hover:border-pink-600':
                    page.progress_goal > page.progress,
                }"
              >
                <!-- Use when progress bar is NOT OK
                                <div class="absolute inline-block text-center
                                    -ml-8 p-2
                                    border rounded-full border-opacity-25
                                    border-gray-600 bg-gray-300 group-hover:border-gray-600"
                                >
                                -->
                <icon
                  v-if="page.progress_goal <= page.progress"
                  name="checkmark"
                  class="text-teal-600 h-1.5 w-1.5"
                />
                <icon
                  v-else
                  name="close"
                  class="text-pink-600 h-1.5 w-1.5"
                />
              </div>

              <router-link
                :id="`form-menu-${page.name}`"
                :to="{
                  name: mod.name + page.name,
                  params: { id: infosPass.id_pass },
                }"
                class="hover:font-normal transition-all ease-in-out duration-150"
              >
                {{ page.order }}.

                {{ getLibelle({ module: mod, page }) }}
              </router-link>
            </li>
            <li
              v-if="
                mod.pages.filter(
                  (p) =>
                    getLibelle({ module: mod, page: p }) !== false ||
                    [constants.PAGE_NEOPASS_FORM_DOCUMENTS].includes(p.name)
                ).length < 1
              "
              class="mt-5 pb-6 pl-6 ml-5 border-l border-gray-600 border-opacity-25 last:border-0 group list-none relative text-gray-600 text-sm font-light"
            >
              Aucun poste lié à une fiche de poste
            </li>
            <!-- END List pages -->
          </ul>
        </li>
        <!-- END List modules -->
      </ul>
    </div>
  </div>
</template>

<script>
import axios from '../api';
import { mapGetters, mapMutations } from 'vuex';
import Icon from './Icon';
import Layout from '../mixins/Layout';
import Constants from './../constants';
import ClickOutside from 'vue-click-outside';

export default {
  name: 'MenuFormulaire',
  components: {
    Icon,
  },

  mixins: [Layout],

  data: function () {
    return {
      premiumPermissions: [],
      constants: Constants,
    };
  },

  mounted() {
    axios.get('/api/permissions/premiumPermissions').then((response) => {
      this.premiumPermissions = response.data;
    });
  },

  computed: {
    ...mapGetters({
      listModulesPages: 'neopass/listModulesPages',
      infosPage: 'neopass/infosPage',
      infosPass: 'neopass/infosPass',
      role: 'auth/role',
    }),

    filteredModules() {
      return this.listModulesPages.filter(
        (m) =>
          !(
            m.name === Constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS &&
            this.role === Constants.ROLE_BENEFICIAIRE
          )
      );
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
